/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
import nobox = Nobox.CRM;
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class LeadDialog extends NoboxEntityDialog<LeadRow, any> {
        protected getFormKey() { return LeadForm.formKey; }
        protected getIdProperty() { return LeadRow.idProperty; }
        protected getLocalTextPrefix() { return LeadRow.localTextPrefix; }
        protected getNameProperty() { return LeadRow.nameProperty; }
        protected getService() { return LeadService.baseUrl; }
        protected getDeletePermission() { return LeadRow.deletePermission; }
        protected getInsertPermission() { return LeadRow.insertPermission; }
        protected getUpdatePermission() { return LeadRow.updatePermission; }

        protected form = new LeadForm(this.idPrefix);

        public isReadonly: boolean;
        private linkcontactsGrid: Chat.ChatContactLinkGrid;
        private conversationGrid: ChatConversationGrid;
        private taskcontactsDialog: nobox.TaskKanbanDialog;
        private dealcontactsDialog: nobox.DealsKanbanDialog;
        public IdLink: number;
        private country: string;
        private states: string;
        private city: string;
        private name: string;
        private address: string;
        private zipcode: string;
        private profil: string;
        private isblock: boolean;
        private userLogin;
        private jmlNote: number = 0;
        private groupNotePropertyGrid: Serenity.PropertyGrid;
        private groupNoteForm: nobox.GroupNotesForm;
        private groupNoteValidator: JQueryValidation.Validator;
        public callback = (response) => {

        }
        constructor() {
            super();
            var $this = this;
            this.linkcontactsGrid = new Chat.ChatContactLinkGrid(this.byId('LinksGrid'));
            this.conversationGrid = new ChatConversationGrid(this.byId('ConversationGrid'));
            this.linkcontactsGrid.openDialogsAsPanel = true;
            this.byId('LinksGrid').detach().appendTo(this.form.linkGrid.element.find(".container-linkcontact"));
            this.taskcontactsDialog = new nobox.TaskKanbanDialog(this.byId('kontakkanban'), this.byId('kontakcalendar'), true);
            this.taskcontactsDialog.dialogOpen();
            this.dealcontactsDialog = new nobox.DealsKanbanDialog(this.byId('kontakdealkanban'), this.byId('kontakdealcalendar'), true);
            this.dealcontactsDialog.dialogOpen();
            $(`a[href='#${this.byId('TabTask').attr("id")}']`).on("click", () => {
                this.taskcontactsDialog.contactId = this.get_entityId();
                this.taskcontactsDialog.refreshSize();
            });
            $(`a[href='#${this.byId('TabDeal').attr("id")}']`).on("click", () => {
                this.dealcontactsDialog.contactId = this.get_entityId();
                this.dealcontactsDialog.refreshSize();
            });
            $(`a[href='#${this.byId('TabConversation').attr("id")}']`).on("click", () => {
                this.conversationGrid.contactId = this.get_entityId();
            });
            //$(`a[href='#${this.byId('TabLink').attr("id")}']`).on("click", () => {
            //    this.linkcontactsGrid.contactId = this.get_entityId();
            //});
            $(`a[href='#${this.byId('TabNote').attr("id")}']`).on("click", () => {
                if (this.jmlNote == 0) {
                    this.getNotes(this.userLogin, false);
                } else {
                    this.getNotes(this.userLogin, true);
                }
            });

            this.groupNotePropertyGrid = new Serenity.PropertyGrid(this.byId("GroupNotePropertyGrid"), {
                idPrefix: this.idPrefix + "_GroupNote_",
                items: Q.getForm(nobox.GroupNotesForm.formKey),
                useCategories: true
            });
            this.groupNoteForm = new nobox.GroupNotesForm(this.groupNotePropertyGrid.get_idPrefix());
            this.groupNoteValidator = this.byId("GroupNoteForm").validate(Q.validateOptions({}));

            this.groupNoteForm.Notes.element.parents(".categories").append(`<div class="field custom-note"><textarea rows="3" type="text" data-act="add" placeholder="Type note here.." class="input-note" name="note" style="flex:1 1 auto;"></textarea><a class="inplace-button button-kirim-catatan" style="width:26px !important;" title="Add Note"><b><i class="fa fa-paper-plane text-primary"></i></b></a></div>`);
            this.groupNoteForm.Notes.element.parents(".categories").append(`<div class="nk-reply-meta mx-1 toggle-note" style="cursor: pointer;"><div class="nk-reply-meta-info"><strong><i class="fa fa-caret-down pr-1"> </i>List Note</strong></div></div>`);
            this.groupNoteForm.Notes.element.parents(".categories").append(`<div class="nk-block block-res-msg note-container"></div>`);


            $this.groupNoteForm.Notes.element.parents(".categories").find(".toggle-note").on("click", function () {
                if ($this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").is(":visible")) {
                    $(this).find("strong i").remove();
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").slideUp(500)
                    $(this).find("strong").prepend(`<i class="fa fa-caret-up pr-1"> </i>`)
                } else {
                    $(this).find("strong i").remove();
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").slideDown(500)
                    $(this).find("strong").prepend(`<i class="fa fa-caret-down pr-1"> </i>`)
                }
            })
            $this.groupNoteForm.Notes.element.parents(".categories").find(".button-kirim-catatan").on("click", function () {
                if ($this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-act") == "add") {
                    $this.addNote();
                } else {
                    $this.updateNote();
                }
            });
            $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().keyup(function (e) {
                if (e.keyCode === 13 && !e.shiftKey) {
                    if ($(this).attr("data-act") == "add") {
                        $this.addNote();
                    } else {
                        $this.updateNote();
                    }
                }
            })
        }
        protected getToolbarButtons() {
            var $this = this;
            var buttons = super.getToolbarButtons();
            buttons.push({
                title: this.getButtonTitle("VCard"),
                icon: "fa-address-card text-blue",
                cssClass: "btn-vcard",
                visible: false,
                separator: true,
                onClick: () => {
                    var link = document.createElement('a');
                    link.href = Q.resolveUrl(`~/Services/Nobox/Contact/VCard/${this.get_entityId()}`);
                    link.click()
                }
            });
            buttons.push({
                title: this.getButtonTitle("Merge Contact"),
                icon: "fa-users-cog text-blue",
                cssClass: "btn-merge",
                visible: false,
                separator: true,
                onClick: () => {
                    var dlg = new MergeContactDialog();
                    dlg.dialogLead = $this;
                    dlg.loadNewAndOpenDialog();
                    //var link = document.createElement('a');
                    //link.href = Q.resolveUrl(`~/Services/Nobox/Contact/VCard/${this.get_entityId()}`);
                    //link.click()
                }
            });
            return buttons;
        }
        protected updateInterface() {
            super.updateInterface();
            var $this = this;
            this.form.Country.element.autocomplete({
                minLength: 3,
                source: function (request, response) {
                    Master.CountriesService.List({
                        ContainsField: Master.CountriesRow.Fields.Name,
                        ContainsText: request.term,
                        IncludeColumns: [Master.CountriesRow.Fields.Name],
                        Take: 10
                    }, res => {
                        response($.map(res.Entities, function (item) {//data needs to be array of objects
                            return { label: item.Name, value: item.Name };//item is each item in array item.LastName
                        }))
                    }, {
                        blockUI: false
                    })
                }
            });
            this.form.State.element.autocomplete({
                minLength: 3,
                source: function (request, response) {
                    Master.StatesService.List({
                        ContainsField: Master.StatesRow.Fields.Name,
                        ContainsText: request.term,
                        IncludeColumns: [Master.StatesRow.Fields.Name],
                        Take: 10
                    }, res => {
                        response($.map(res.Entities, function (item) {//data needs to be array of objects
                            return { label: item.Name, value: item.Name };//item is each item in array item.LastName
                        }))
                    }, {
                        blockUI: false
                    })
                }
            });
            this.form.City.element.autocomplete({
                minLength: 3,
                source: function (request, response) {
                    Master.CitiesService.List({
                        ContainsField: Master.CitiesRow.Fields.Name,
                        ContainsText: request.term,
                        IncludeColumns: [Master.CitiesRow.Fields.Name],
                        Take: 10
                    }, res => {
                        response($.map(res.Entities, function (item) {//data needs to be array of objects
                            return { label: item.Name, value: item.Name };//item is each item in array item.LastName
                        }))
                    }, {
                        blockUI: false
                    })
                }
            });
            this.userLogin = this.get_entity().User;

            $this.groupNoteForm.Notes.element.parents(".categories").find(".edit-note").unbind();
            $this.groupNoteForm.Notes.element.parents(".categories").find(".edit-note").on("click", function () {
                $this.editNote($(this).attr("data-note-id"));
            });
            if ($this.isEditMode()) {
                this.linkcontactsGrid.contactId = this.get_entityId();
                this.element.find(".btn-vcard").show();
                this.element.find(".btn-merge").show();
            }
        }
        protected save(callback) {
            var $form = this.form;
            this.name = $form.Name.value;
            this.country = $form.Country.value;
            this.states = $form.State.value;
            this.city = $form.City.value;
            this.address = $form.Address.value;
            this.zipcode = $form.Postal.value;
            this.profil = $form.Photo.value;
            this.isblock = $form.IsBlock.value;
            super.save(callback);
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
            //this.dialogClose();
            this.callback({
                Id: response.EntityId,
                Name: this.name,
                Country: this.country,
                State: this.states,
                City: this.city,
                Address: this.address,
                ZipCode: this.zipcode,
                Profil: this.profil,
                IsBlock: this.isblock
            });
        }
        protected editor = new CustomFieldsDataEditor(this.form.Custom.element, { Menu: CustomFieldsDataEnum.Contact } as ICustomFieldsDataEditorOptions);
        loadEntity(entity: LeadRow) {
            super.loadEntity(entity);
            //Serenity.TabsExtensions.setDisabled(this.tabs, 'Link', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Task', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Conversation', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Note', this.isNewOrDeleted());
            if (this.isNewOrDeleted()) {
                this.form.In.element.closest('.category').toggle(false);
            }
            if (this.isEditMode()) {
                this.form.In.element.closest('.category').toggle(true);
                this.taskcontactsDialog.onBoardRender = () => {
                    if (this.byId('TabNote').is(":visible")) {
                        this.byId('TabTask').hide();
                        this.byId('TabDeal').hide();
                    }
                    if (this.byId('TabConversation').is(":visible")) {
                        this.byId('TabTask').hide();
                        this.byId('TabDeal').hide();
                    }
                    if (this.byId('TabContact').is(":visible")) {
                        this.byId('TabTask').hide();
                        this.byId('TabDeal').hide();
                    }
                    //if (this.byId("TabLink").is(":visible")) {
                    //    this.byId('TabTask').hide();
                    //    this.byId('TabDeal').hide();
                    //}
                    if (this.byId("TabDeal").is(":visible")) {
                        this.byId('TabTask').hide();
                    }
                    if (this.byId("TabTask").is(":visible")) {
                        this.byId('TabDeal').hide();
                    }
                }
                this.dealcontactsDialog.onBoardRender = () => {
                    if (this.byId('TabNote').is(":visible")) {
                        this.byId('TabTask').hide();
                        this.byId('TabDeal').hide();
                    }
                    if (this.byId('TabConversation').is(":visible")) {
                        this.byId('TabTask').hide();
                        this.byId('TabDeal').hide();
                    }
                    if (this.byId('TabContact').is(":visible")) {
                        this.byId('TabTask').hide();
                        this.byId('TabDeal').hide();
                    }
                    //if (this.byId("TabLink").is(":visible")) {
                    //    this.byId('TabTask').hide();
                    //    this.byId('TabDeal').hide();
                    //}
                    if (this.byId("TabDeal").is(":visible")) {
                        this.byId('TabTask').hide();
                    }
                    if (this.byId("TabTask").is(":visible")) {
                        this.byId('TabDeal').hide();
                    }
                }
            }
            this.editor.isNew = this.isNew();
            this.editor.set_value(!Q.isEmptyOrNull(entity.Custom) && this.isValidJSON(entity.Custom) ? JSON.parse(entity.Custom) : [])
        }
        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }

        regexDateTime(format) {
            return format.replace(new RegExp("%2C", 'g'), ",").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%20", 'g'), " ").replace(new RegExp("%3A", 'g'), ":");
        }
        addNote() {
            var pesan = Q.trim(this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val());
            var $this = this;
            if (pesan == "" || pesan == null) {

            } else {
                Q.serviceCall({
                    blockUI: false,
                    url: "/Services/Nobox/Lognotes/Create",
                    request: {
                        Entity: {
                            NmMenu: "Contact",
                            IdModul: this.get_entityId(),
                            Activity: "Added a note",
                            Type: "note",
                            Comment: pesan
                        },
                    },
                    onSuccess: (response) => {
                        $this.getNotes(this.userLogin, false);
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val("");
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-act", "add")
                    }
                });
            }
        }

        updateNote() {
            var pesan = Q.trim(this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val());
            var $this = this;
            if (pesan == "" || pesan == null) {

            } else {
                Q.serviceCall({
                    blockUI: false,
                    url: "/Services/Nobox/Lognotes/Update",
                    request: {
                        EntityId: $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-id"),
                        Entity: {
                            NmMenu: "Contact",
                            IdModul: this.get_entityId(),
                            Activity: "Updated a note",
                            Type: "note",
                            Comment: pesan
                        },
                    },
                    onSuccess: (response) => {
                        $this.getNotes(this.userLogin, false);
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().val("");
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-act", "add")
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").first().attr("data-id", "");
                    }
                });
            }
        }

        editNote(id) {
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").val($(".data-text" + id).text());
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").attr("data-act", "edit")
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").attr("data-id", id)
            this.groupNoteForm.Notes.element.parents(".categories").find(".input-note").focus();
        }
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);

            if (parts[1] == undefined) {
                if (name == "formatdate") {
                    return "DD-MM-YYYY";
                } else if (name == "formattime") {
                    return "HH:mm";
                } else if (name == "timezone") {
                    return "Asia/Jakarta";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }
        getNotes(UserSource, isMore) {
            var $this = this;
            var arrNote = [];
            var kemarin = moment().utc().add(-1, 'd').format("DD-MM-YYYY");
            this.jmlNote = isMore == false ? 0 : this.jmlNote;
            Q.serviceCall({
                blockUI: false,
                url: "/Services/Nobox/Lognotes/List",
                request: {
                    EqualityFilter: { NmMenu: "Contact", IdModul: $this.get_entityId(), Type: "note" },
                    IncludeColumns: ["Type", "Tgl", "UserId", "Comment", "Activity", "userImg", "userlog"],
                    ColumnSelection: 1,
                    Skip: this.jmlNote,
                    Take: 5,
                    Sort: ["Tgl DESC"]
                },
                onSuccess: (resLog: Serenity.ListResponse<nobox.LognotesRow>) => {
                    arrNote = resLog.Entities;
                    this.jmlNote = this.jmlNote == undefined ? 0 + arrNote.length : this.jmlNote + arrNote.length;
                    if (arrNote.length) {
                        arrNote.forEach(function (e, eindx) {
                            if (eindx == 0 && isMore == false) {
                                $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").html("");
                            }
                            var UserImg = ""
                            if (Q.isEmptyOrNull(e.userImg)) {
                                UserImg = `<div class="user-lkavatar">
                                                <span>${e.userlog.charAt(0).toUpperCase()}</span>
                                            </div>`
                            } else {
                                UserImg = `<div class="user-lkavatar">
                                                <img style="width:inherit;" src="/upload/${e.userImg}">
                                            </div>`
                            }
                            var strTgl = "";
                            if (moment(e.Tgl).utc().format("DD-MM-YYYY") == moment().utc().format("DD-MM-YYYY")) {
                                strTgl = "Today " + moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formattime")));
                            } else if (moment(e.Tgl).utc().format("DD-MM-YYYY") == kemarin) {
                                strTgl = "Yesterday " + moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formattime")));
                            } else if (moment(e.Tgl).utc().format("YYYY") == moment().utc().format("YYYY")) {
                                strTgl = moment(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formatdate")) + ", " + $this.regexDateTime($this.getCookie("formattime")));
                            } else {
                                strTgl = moment.utc(e.Tgl).utc().tz($this.regexDateTime($this.getCookie("timezone"))).format($this.regexDateTime($this.getCookie("formatdate")) + ", " + $this.regexDateTime($this.getCookie("formattime")));
                            }
                            var tmpMsg = $("");
                            var strEdit = e.UserId == UserSource.UserId ? ` <span class="sub-text pl-1"><i class="fas fa-edit text-primary edit-note" data-note-id="${e.Id}" style="cursor:pointer;" title="Edit this note"></i></span>` : '';
                            var strDelete = e.UserId == UserSource.UserId ? ` <span class="sub-text pl-1"><i class="fas fa-trash text-danger delete-note" data-note-id="${e.Id}" style="cursor:pointer;" title="Delete this note"></i></span>` : '';
                            tmpMsg = $(`
                        <div class="user-lkcard bg-lighter p-2 m-1">
                            ${UserImg}
                            <div class="user-info">
                                <span class="lead-text lead-text${e.Id}">${e.userlog.toString()}<span class="text-muted small p-1"> - ${strTgl}</span><span class="text-muted small">(${e.Activity})</span>${strEdit + strDelete}</span>
                                <span class="sub-text data-text${e.Id}">${e.Comment}</span>
                            </div>
                        </div>`);
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(tmpMsg);
                        });
                        if (this.jmlNote % 5 == 0) {
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(`<div class="center inplace-button text-blue pl-1 pr-1 more-note" style="margin: auto;width: fit-content;font-weight: 500;">Show more</div>`)
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".more-note").on("click", function () {
                                $this.getNotes(UserSource, true);
                                $(".more-note").remove();
                            });
                        }
                        if (arrNote.length == 0 && isMore == true) {
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").html("");
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(`
                    <div class="user-lkcard bg-lighter p-2 m-1 justify-content-center note-content">
                        <div class="user-info">
                            <span class="text-muted">No note yet.</span>
                        </div>
                    </div>`);
                        }
                    }
                    else {
                        if (isMore == false && this.jmlNote < 1) {
                            $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").html("");
                        }
                        $this.groupNoteForm.Notes.element.parents(".categories").find(".note-container").append(`<div class="center" style="margin: auto;width: fit-content;">No more notes...</div>`)
                    }
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".edit-note").unbind();
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".edit-note").on("click", function () {
                        $this.editNote($(this).attr("data-note-id"));
                    });
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".delete-note").unbind();
                    $this.groupNoteForm.Notes.element.parents(".categories").find(".delete-note").on("click", function () {
                        var idDel = $(this).attr("data-note-id");
                        Q.confirm("Delete note?", function () {
                            Q.serviceCall({
                                blockUI: false,
                                url: "/Services/Nobox/Lognotes/Delete",
                                request: {
                                    EntityId: idDel
                                },
                                onSuccess: (hasil) => {
                                    $this.getNotes(UserSource, false);
                                }
                            })
                        })
                    });
                }
            });
        }

        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
                        <ul>
                            <li><a href="#~_TabContact"><span>Info</span></a></li>
                            <li><a href="#~_TabConversation"><span>Conversations</span></a></li>
                            <li><a href="#~_TabTask"><span>Tasks</span></a></li>
                            <li><a href="#~_TabDeal"><span>Deals</span></a></li>
                            <li><a href="#~_TabNote"><span>Notes</span></a></li>
                        </ul>
                        <div id="~_TabContact" class="tab-pane s-TabContact">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabLink" class="tab-pane s-TabLink" style="display:none;">
                            <div id="~_LinksGrid">
                            </div>
                        </div>
                        <div id="~_TabConversation" class="tab-pane s-TabConversation">
                            <div id="~_ConversationGrid">
                            </div>
                        </div>
                        <div id="~_TabTask" class="tab-pane s-TabTask" style="display: none;">
                            <div id="~_kontakkanban"></div>
                            <div id="~_kontakcalendar" class="pt-2"style="display:none;"></div>
                            <div class="s-Form d-none">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabDeal" class="tab-pane s-TabDeal" style="display: none;">
                            <div id="~_kontakdealkanban"></div>
                            <div id="~_kontakdealcalendar" class="pt-2"style="display:none;"></div>
                            <div class="s-Form d-none">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabNote" class="tab-pane s-TabNote">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_GroupNoteForm" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_GroupNotePropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>`;
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.isReadonly == true) {
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                this.element.find('sup').hide();
                this.saveAndCloseButton.remove();
                this.applyChangesButton.remove();
                this.deleteButton.remove();
                if (this.isEditMode()) {
                    var entityType = super.getEntitySingular();

                    // get name field value of record this dialog edits
                    let name = this.getEntityNameFieldValue() || "";

                    // you could use format with a local text, but again demo...
                    this.dialogTitle = 'View ' + entityType + " (" + name + ")";
                }
            }
        }

        onDialogClose() {
            this.taskcontactsDialog.dialogClose();
            this.dealcontactsDialog.dialogClose();
        }
        dialogClose() {
            this.taskcontactsDialog.dialogClose();
            this.dealcontactsDialog.dialogClose();
            super.dialogClose();
        }


        getSaveEntity() {
            var entity = super.getSaveEntity();
            entity.Custom = JSON.stringify(this.editor.get_value());
            return entity;
        }
    }
}